import React from 'react';
import { Route } from 'react-router';

import { routes } from '@seek/seek-jobs-seo';
import App from './handlers/App';
import Home from './handlers/Home';
import SearchResults from './handlers/SearchResults';
import PageNotFound from 'PageNotFound/PageNotFound';
import Search from 'Search/Search';

export default (
  <Route component={App}>
    <Route component={Search}>
      <Route path="/" component={Home} />
      { routes.map(path => <Route key={path} path={path} component={SearchResults} />) }
    </Route>
    <Route path="*" component={PageNotFound} />
  </Route>
);



/** WEBPACK FOOTER **
 ** ./app/routes.js
 **/